
/*------------------------------------------------------------------
  - This sccript for adding product variants for seller to sell his item
-------------------------------------------------------------------*/


$( document ).ready(function() { 
  $('.product_variants_option_value_1').dropdown({allowAdditions: true,maxSelections: 50});
  $('.product_variants_option_value_2').dropdown({allowAdditions: true,maxSelections: 50});
  $('.product_variants_option_value_3').dropdown({allowAdditions: true,maxSelections: 50});
  //Opening modal window
  //Opening modal window on click of button
  $('.dp_product_btn').click(function (){
    //$('._product_btn').dropdown({allowAdditions: true});
    var addProductVariantPopup = $('.duplicate-product-modal');
  	addProductVariantPopup.bPopup({
      positionStyle: 'fixed',
      scrollBar: 'true',
      closeClass: 'modal__close'
    });
  });
  
   function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return "";
  }

     $("#dp_product_price").change(function(){    
    
     //$('#taxable_original_price').val($('#product_price').val());
      var gstPercentage = $("#duplicate_gst_percentage").val();
      var productPrice = $("#dp_product_price").val();
      var gstPrice = parseInt(productPrice)  / (1+(gstPercentage/100));
      $('#duplicate_taxable_original_price').val(gstPrice.toFixed(2));
    	
       var duplicateTaxableOriginalPrice =  $('#duplicate_taxable_original_price').val();
       
       if(duplicateTaxableOriginalPrice == 'NaN'){
          $('#duplicate_taxable_original_price').val(0);
       }
      
  });
  
  $("#dp_product_offer_price").change(function(){
    // $('#taxable_final_price').val($('#product_offer_price').val());
    var gstPercentage = $("#duplicate_gst_percentage").val();
    var productOfferPrice = $('#dp_product_offer_price').val();
    var productOfferPriceWithGst = parseInt(productOfferPrice)  / (1+(gstPercentage/100));
    $('#duplicate_taxable_final_price').val(productOfferPriceWithGst.toFixed(2));
	var duplicateTaxableFinalPriceValue = $('#duplicate_taxable_final_price').val();
    if(duplicateTaxableFinalPriceValue == 'NaN'){
       $('#duplicate_taxable_final_price').val(0);
    }
    
  });
  
  $("#duplicate_gst_percentage").change(function(){  
    var gstPercentage = $("#duplicate_gst_percentage").val();
    var productOfferPrice = $('#dp_product_offer_price').val();
    var productPrice = $("#dp_product_price").val();
    var gstPrice = parseInt(productPrice)  /(1+(gstPercentage/100));
	 $('#duplicate_taxable_original_price').val(gstPrice.toFixed(2));
    
    var duplicateTaxableOriginalPrice =  $('#duplicate_taxable_original_price').val()
     if(duplicateTaxableOriginalPrice == 'NaN'){
         $('#duplicate_taxable_original_price').val(0);
      }
    var productOfferPriceWithGst = parseInt(productOfferPrice)  /(1+(gstPercentage/100));
	 $('#duplicate_taxable_final_price').val(productOfferPriceWithGst.toFixed(2));
	var duplicateTaxableFinalPriceValue = $('#duplicate_taxable_final_price').val();
    if(duplicateTaxableFinalPriceValue == 'NaN'){
       $('#duplicate_taxable_final_price').val(0);
    }
  });
  
  //Validating product form
  function productValidation(){
    var decimal=  /^[-+]?[0-9]+\.[0-9]+$/;
     var alphabetFormat = /^[a-zA-Z]+$/;
      var alphaNumericFormat = /^[a-zA-Z0-9]+$/
      
    var title = $('#dp_title').val(),
        quantity = $('#dp_product_quantity').val(),
        product_price = $('#dp_product_price').val(),
        product_offer_price = $('#dp_product_offer_price').val(),
        product_description = $('#dp_product_description').val(),
        product_size =$('#duplicateProductSize').val(),
        product_color = $('#duplicateProductColor').val(),
        product_material = $('#duplicateProductMaterial').val(),
        product_care = $('#duplicateProductCare').val(),
  		product_sku = $('#dp_product_sku').val(),
        product_label = $('#duplicate_product_label').val(),
     //   product_label = $('#duplicate_product_label').val().split(" ").length - 1,
        deliveryTimeline = $('#dp_delivery_timeline').val(),
    	weight = $('#dp_product_weight').val(),
     	hsn_code = $('#duplicate_hsn_code').val(),
        gst_percentage = $('#duplicate_gst_percentage').val();
    
    
	$(".error_tag").hide();
    
    var isvalid = true;
    
    var gstRegisteredSeller = false;
    
    if (readCookie('gst_registered') == 'YES' ){
      gstRegisteredSeller = true;
    } 
    
    if( title == "" ) {
      $('#dp_title').focus();
      $("#dp_title_error").css({'display':'table'}).html("Please enter the title");
      isvalid = false;
    }
    
     if(product_price == ""){
      $('#dp_product_price').focus();
      $("#dp_product_price_error").css({'display':'table'}).html("Please enter product price");
      isvalid = false;
    } else if(!$.isNumeric(product_price)){
   	  $('#dp_product_price').focus();
      $("#dp_product_price_error").css({'display':'table'}).html("Please enter a valid price ex: 100.00 or 100");
      isvalid = false;
    } else if (parseInt(product_price) <= 0){
      $('#dp_product_price').focus();
      $("#dp_product_price_error").css({'display':'table'}).html("Product price cannot be 0");
      isvalid = false;
    }
    
    if(product_offer_price != ""){
      if(!$.isNumeric(product_offer_price)){
         $('#dp_product_offer_price').focus();
          $("#dp_product_offer_price_error").css({'display':'table'}).html("Please enter a valid price ex: 100.00 or 100");
          isvalid = false;
      } else if(parseInt(product_offer_price) <= 0){
      	 $('#dp_product_offer_price').focus();
         $("#dp_product_offer_price_error").css({'display':'table'}).html("Product price cannot be 0");
         isvalid = false;
      }else if(parseInt(product_offer_price) > parseInt(product_price)){
         
        $('#dp_product_offer_price').focus();
         $("#dp_product_offer_price_error").css({'display':'table'}).html("Offer price should not be greater than product original price");
         isvalid = false;
      }
    }
   
    
    if(gstRegisteredSeller){
        if( hsn_code == "" ) {
          $('#duplicate_hsn_code').focus();
          $("#duplicate_hsn_code_error").css({'display':'table'}).html("Please enter HSN code");
          isvalid = false;
      	}
      
        if(gst_percentage == '') {
          $('#duplicate_gst_percentage').focus();
          $("#duplicate_gst_percentage_error").css({'display':'table'}).html("Please select GST percentage");
          isvalid = false;
        }
    }
    
    if(deliveryTimeline == '0') {
      $('#dp_delivery_timeline').focus();
      $("#dp_delivery_timeline_error").css({'display':'table'}).html("Please select delivery timeline");
      isvalid = false;
    }

    if(weight == '0') {
      $('#dp_product_weight').focus();
      $("#dp_weight_error").css({'display':'table'}).html("Please select weight");
      isvalid = false;
    }
    if(quantity == "" ) {
      $('#dp_quantity').focus()
      $("#dp_quantity_error").css({'display':'table'}).html("Please enter the quantity");
      isvalid = false;
    }else if(!$.isNumeric(quantity)) {
      $('#dp_quantity').focus();
      $("#dp_quantity_error").css({'display':'table'}).html("Please enter the valid quantity number ex: 1 or 12");
      isvalid = false;
    }

    if(product_description == ""){
      $("#dp_product_description").focus();
      $("#duplicate_description_error").css({'display':'table'}).html("Please add description");
    //  return false;
      isvalid = false;
    }
    
    var selectProdutTypeduplicate = document.getElementById('duplicate_product_type');
    if (!selectProdutTypeduplicate.value) {
      $('#duplicate_product_type_error').css({'display':'table'}).html("Please select a product type");
		isvalid = false;     
    }
    
    if(product_size == ""){
      $('#duplicateProductSize').focus();
      $("#duplicate_size_error").css({'display':'table'}).html("Please enter dimensions available for your product");
    //  return false;
      isvalid = false;
    } 
    if(product_color == ""){
       $('#duplicateProductColor').focus();
       $("#duplicate_color_error").css({'display':'table'}).html("Please enter color/s for your product");
   //    return false;
      isvalid = false;
    }
  	
    if(product_material == ""){
      $('#duplicateProductMaterial').focus();
      $("#material_error").css({'display':'table'}).html("Please enter material for your product");
    //  return false;
      isvalid = false;
    }
 //  return false;
     if (!alphaNumericFormat.test(product_sku)  && product_sku != "" ) {
        $('#dp_product_sku').focus();
        $("#dp_sku_error").html("Please enter valid stock keep unit having alphabets and numeric value").fadeIn();
     //  return false;
       isvalid = false;
      } else if (product_sku != "" && product_sku.length >= 10 ) {
        $('#dp_product_sku').focus();
        $("#dp_sku_error").html("Please enter sku value of lenghth less than 10").fadeIn();
    //    return false;
        isvalid = false;
      }
  /*  if(product_label > 0){
      
    $('#duplicate_product_label').focus();
    $("#duplicate_product_label_error").css({'display':'table'}).html("Please add label of one word");
       return false;
    
    }*/
    
    return isvalid;
  }
  
  
  // Show product details tab
  $('.dp_toggel_product_div').click(function () {
    $('.dp_image_upload_div').hide();
    $('.dp_product_details_div').fadeIn();
  });
  
  // Show product details tab
  $('.dp_toggel_image_div').click(function (e){
    e.preventDefault();
    //Validating values
    if(productValidation()) {
      $(".error_tag").hide();
      $('.dp_product_details_div').hide();
      $('.dp_image_upload_div').fadeIn();
    }
  });
  
   $('.dp_product_submit').click(function (e){
    e.preventDefault();
    if(validateProductImages()) {
      $(".loding_container").show();
      setTimeout(function() { $('#dp_product_form').submit();
                            }, 100);
    }
  });
  
  // Show product details tab
 /* $('.dp_product_submit').click(function (e){
    e.preventDefault();
    $(".loding_container").show();
    setTimeout(function() { $('#dp_product_form').submit();
                          }, 100);
  });*/
  
  //Saving new duplicate product data
  $("form#dp_product_form").submit(function(e){
    e.preventDefault();
    $(".loding_container").fadeIn();
    var addProductSubmitBtn = $('#dp_product_submit');  // submit button
    addProductSubmitBtn.html('Saving...');
    addProductSubmitBtn.prop('disabled', true); // disable button
    addProductSubmitBtn.attr("disabled", true); // disable button
    var formData = new FormData($("#dp_product_form")[0]);

    //Adding all product image url's
    for (var i = 0; i < product_img_arr.length; i++) {
      formData.append('upload_img_url[]',product_img_arr[i]);
    }
    var token = readCookie('token');

    $.ajax({
      //url: "https://test-designers.lovethisstuff.com/website/product/createDuplicateProduct",
      url: 'https://api-test.lovethisstuff.com/v1/products/saveProductAPI?token='+token+'',
      type: 'POST',
      data: formData,
      processData: false,
      async: true,
      beforeSend: function() {
        addProductSubmitBtn.html('Saving ...');
        addProductSubmitBtn.prop('disabled', true); // disable button
        addProductSubmitBtn.attr('disabled', true); // disable button
      },
      success: function (data) {
        $(".loding_container").fadeOut();
        if(data.messageType === "SUCCESS") {
          addProductSubmitBtn.html('Saved');
          addProductSubmitBtn.prop('disabled', true); // disable button
          addProductSubmitBtn.attr('disabled', true); // disable button
          $('.api_error').hide();
          $('.api_success').hide();
          $('.dp_product_success').html(data.message).fadeIn();
          setTimeout(function(){location.reload();},700);
        } else if(data.messageType === "SESSION_EXPIRED" || data.messageType === "UNAPPROVED") {
          addProductSubmitBtn.html('Submit'); // change submit button text
          addProductSubmitBtn.attr('disabled', false); // disable button
          $('.api_success').hide();
          $('.api_error').hide();
          $('.dp_product_error').html(data.message).fadeIn();
        }
      },
      error : function (data) {
        $(".loding_container").fadeOut();
        addProductSubmitBtn.html('Submit'); // change submit button text
        addProductSubmitBtn.attr("disabled", false); // Enabling button
        addProductSubmitBtn.prop('disabled', false); // disable button
        $('.api_success').hide();
        $('.api_error').hide();
        $('.dp_product_error').html(data.message).fadeIn();
      },
      cache: false,
      contentType: false,
      processData: false
    });
    return false;
  });
  
  function validateProductImages() {
     $(".error_tag").hide();
   
    if(product_img_arr.length == 0){
     
      $("#duplicate_product_image_error").html("Please add at least one image for the product.").fadeIn();
      return false;
    }
    return true;
  }
  
});
  